import {Action} from '@ngrx/store';
import {LatestChangesModel} from '../models/latest_changes.model';

export enum AllLatestChangesActionTypes {
    LOAD_ALL_LATEST_CHANGES = '[All Latest Changes Feature] Emit to load all latest changes',
    CANCEL_LOAD_ALL_LATEST_CHANGES = '[All Latest Changes Feature] Emit to cancel loading all latest changes',
    ALL_LATEST_CHANGES_LOADED = '[All Latest Changes Feature] Emitted when all latest changes have been loaded',
    CLEAR_ALL_LATEST_CHANGES = '[All Latest Changes Feature] Emit to clear all latest changes',
}

export class LoadAllLatestChangesAction implements Action {
    readonly type = AllLatestChangesActionTypes.LOAD_ALL_LATEST_CHANGES;
}

export class CancelLoadAllLatestChangesAction implements Action {
    readonly type = AllLatestChangesActionTypes.CANCEL_LOAD_ALL_LATEST_CHANGES;
}

export class AllLatestChangesLoadedAction implements Action {
    readonly type = AllLatestChangesActionTypes.ALL_LATEST_CHANGES_LOADED;

    constructor(public payload: { latestChanges: LatestChangesModel[] }) {
    }
}

export class ClearAllLatestChangesAction implements Action {
    readonly type = AllLatestChangesActionTypes.CLEAR_ALL_LATEST_CHANGES;
}

export type LatestChangeActions = AllLatestChangesLoadedAction |
    CancelLoadAllLatestChangesAction |
    LoadAllLatestChangesAction |
    ClearAllLatestChangesAction;
